import styled from 'styled-components';
import { TextField } from '../TextField';
import { BaseContainer } from '../BaseContainer';
import { Loader } from '../Loader';
const Input = styled(TextField).withConfig({ displayName: "vui--Input", componentId: "vui--je6y84" }) `flex-grow:2;margin-top:0;margin-bottom:0;`;
const IconContainer = styled.div.withConfig({ displayName: "vui--IconContainer", componentId: "vui--113gfe8" }) `position:absolute;`;
const Container = styled(BaseContainer).withConfig({ displayName: "vui--Container", componentId: "vui--18q9h8i" }) `position:relative;display:flex;justify-content:flex-start;align-items:center;border-radius:0.25rem;${({ iconPosition }) => {
    let padding = 'padding-right: 2.5rem;';
    let position = 'right: 0.5rem;';
    if (iconPosition === 'left') {
        padding = 'padding-left: 2.5rem';
        position = 'left: 0.5rem;';
    }
    return `
      & ${Input} {
        ${padding}
      }

      & ${IconContainer} {
        ${position}
      }
    `;
}}`;
export { Container, Input, IconContainer, Loader };
//# sourceMappingURL=styled.js.map